import React from 'react';

const Hero = () => { // Removed onGetStarted prop as it's no longer used
  return (
    <section className="hero-gradient text-white py-20 px-6">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        {/* Text Content Section */}
        <div className="md:w-1/2 mb-10 md:mb-0">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-pale-gold">✨ Turn Questions</span> into Clarity.
          </h1>
          <p className="text-lg mb-8">
            Research Genie is your AI-powered equity research assistant.
            Ask anything. Get investor-grade insights, models, and reports in seconds.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            {/* Updated Try for Free button */}
            <a
              href="https://equity-research-analyst-611846019618.us-central1.run.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-pale-gold text-midnight-navy px-6 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-colors"
            >
              Try for Free
            </a>
            {/* Watch Demo button is removed */}
          </div>
        </div>

        {/* Image Section */}
        <div className="md:w-1/2 relative flex justify-center items-center mt-10 md:mt-0">
          <img
            src="/images/hero-screenshot.png" // Path relative to public folder
            alt="Research Genie Product Screenshot"
            className="rounded-lg shadow-xl max-w-full h-auto md:max-w-md" // Adjusted styling
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
